import Svg from 'src/Components/shared/Svg'

export const ConfirmationCheckMark = () => {
  return (
    <Svg width={48} height={48} fill='none'>
      <path
        d='M48 24c0 13.222-10.722 24-24 24S0 37.222 0 24 10.722 0 24 0s24 10.778 24 24zm-7.889-5.056c0-.555-.167-1.055-.555-1.444l-2.834-2.833c-.389-.334-.889-.556-1.389-.556a2.22 2.22 0 00-1.444.556L21.167 27.389l-7.056-7.056a2.017 2.017 0 00-1.444-.61c-.5 0-1 .221-1.39.61l-2.833 2.834c-.388.389-.555.889-.555 1.444 0 .5.167 1 .555 1.389l11.334 11.333c.333.334.889.556 1.389.556s1.055-.222 1.444-.556l16.945-17c.388-.389.555-.889.555-1.389z'
        fill='var(--brand-success-700)'
      />
    </Svg>
  )
}
